import { useFormContext } from "react-hook-form";
import TextArea from "@/components/TextArea/TextArea";
import {
  informationFieldConfigValueSchema,
  type IInformationFieldConfigValue,
} from "@/api/Patients";
import { useLingui } from "@lingui/react/macro";

export type ReasonForAdmissionInputFields = {
  reasonForAdmission: string;
};

const ReasonForAdmissionInput = ({
  reasonForAdmissionFieldConfig,
}: {
  reasonForAdmissionFieldConfig: IInformationFieldConfigValue;
}) => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<ReasonForAdmissionInputFields>();

  return (
    <TextArea
      label={t`Inskrivningsorsak`}
      showOptionalLabel={
        reasonForAdmissionFieldConfig ===
        informationFieldConfigValueSchema.enum.optional
      }
      errorMessage={errors.reasonForAdmission?.message}
      {...register("reasonForAdmission", {
        required: {
          value:
            reasonForAdmissionFieldConfig ===
            informationFieldConfigValueSchema.enum.required,
          message: t`Ange inskrivningsorsak`,
        },
      })}
    />
  );
};

export default ReasonForAdmissionInput;
